import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isUndefined } from 'util';
import { LoginAndUserManagerService } from '../../api/managers/login-and-user-manager.service';

@Component({
    selector: 'app-user-email-change-confirmation',
    templateUrl: './user-email-change-confirmation.component.html',
    styleUrls: ['./user-email-change-confirmation.component.less']
})
export class UserEmailChangeConfirmationComponent implements OnInit {
    id;
    email;
    secret;
    isLoading = false;

    message = '';
    isSuccess = false;

    operationSuccess = false;

    constructor(private userManager: LoginAndUserManagerService,
        private router: Router) { }

    ngOnInit() {
        this.id = (this.router.parseUrl(this.router.url)).queryParams.id;
        this.email = (this.router.parseUrl(this.router.url)).queryParams.newemail;
        this.secret = encodeURIComponent((this.router.parseUrl(this.router.url)).queryParams.secret);
        this.secret = String(this.secret.replace('%', '')).toLowerCase();
        if (isUndefined(this.id) || isUndefined(this.secret) || isUndefined(this.email)) {
            this.router.navigateByUrl('welcome');
        }
    }

    onResetEmail() {
        this.isLoading = true;
        this.userManager.resetEmail({
            id: this.id,
            email: this.email,
            secret: this.secret
        }).subscribe((response) => {
            this.isLoading = false;
            this.message = `Success! Your email address has been changed. <br><br><span class='warning'>Note: You will now be logged out and from now on, you must log in using your email address, ${response}.</span>`;
            this.isSuccess = true;
            this.operationSuccess = true;
            setTimeout(() => { this.userManager.signOut(); }, 10 * 1000);
        }, (error) => {
            this.operationSuccess = false;
            this.isLoading = false;
            const errorMsg: string = error['error']['Message'].toString();
            this.message = errorMsg; // errorMsg.includes('authorization credentials') ? 'Please log in and try the link again' : errorMsg;
            this.isSuccess = false;
        });
    }

}
